import { render, staticRenderFns } from "./details-threshold.vue?vue&type=template&id=3eb237b6&"
import script from "./details-threshold.vue?vue&type=script&lang=ts&"
export * from "./details-threshold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports